ACC.repairProductsAjax = {
  omnitureType: 'interaction',
  phAccToggle: 'accordion-toggle',
  populateProductTypeDropdown: function() {
    var productTypeOptions = '';

    $.ajax({
      url: ACC.config.contextPath + 'repair-product/product-type-repairs',
      type: 'GET',
      dataType: 'json',
      success: function(data) {
        productTypeOptions = ACC.repairProducts.productTypeOptionIteration(data);
        $(ACC.repairProducts.productTypeDropDown).selectBox('destroy');
        $(ACC.repairProducts.productTypeDropDown).append(productTypeOptions);
        $(ACC.repairProducts.productTypeDropDown).selectBox({
          mobile: 'true'
        });
        ACC.common.refreshSelectBoxArrow();
      },
      error: function() {
        $('.ph-json').text('Error');
      }
    });
  },

  getProductInfoDetails: function() {
    var serialNumber = {
      materialSerialNumber: ''
    };

    serialNumber.materialSerialNumber = $('#' + ACC.repairProducts.serialNumberInput).val();

    $.ajax({
      url: ACC.config.contextPath + 'warranty-search/warranty-search-for-serial?repairFlow=Y',
      type: 'POST',
      data: serialNumber,
      dataType: 'json',
      success: function(data) {
        var serilizedListMsg = $('.ph-serialized_list_message').text();

        ACC.repairProducts.productInfosDetailedList = [];
        ACC.repairProducts.checkForInvalidSerialNumbers(data, true);

        if (data && data.warrantyDuplicationHybrisList.length > 0) {
          ACC.repairProducts.warrantyDuplicationHybrisList = data.warrantyDuplicationHybrisList;
        }

        if (data && data.warrantyInfosDetailedList.length > 0) {
          ACC.repairProducts.warrantyInfosDetailedList = data.warrantyInfosDetailedList;
          ACC.repairProductsAjax.serialSearchOmnitureTagging(ACC.repairProducts.warrantyInfosDetailedList);
          $('#' + ACC.repairProducts.repairsProductList).html($('#repairsProductTemplate').tmpl({
            addresses: data.warrantyInfosDetailedList
          }));
          $('.' + ACC.repairProducts.repairProductsContainer).show();
          $('.ph-repairsproduct_header').text(serilizedListMsg);
        }
      },
      error: function() {
        ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, 'create_repair_request:product_info:search:failure:serialnumber');
        $('.ph-json').text('Error');
      }
    });
  },

  getMaterialSearchInfoDetails: function(materialNumber) {
    var serialNumber = {
      materialSerialNumber: ''
    };

    serialNumber.materialSerialNumber = materialNumber;

    $.ajax({
      url: ACC.config.contextPath + 'warranty-search/warranty-search-for-material',
      type: 'POST',
      data: serialNumber,
      dataType: 'json',
      success: function(data) {
        var nonSerilizedListMsg = $('.ph-nonserialized_list_message').text();

        ACC.repairProducts.productInfosDetailedList = [];
        ACC.repairProducts.checkForInvalidSerialNumbers(data, false);

        if (data && data.materialDescriptionList.length > 0) {
          ACC.repairProducts.warrantyInfosDetailedList = data.materialDescriptionList;
          $('#' + ACC.repairProducts.repairsProductList).html($('#repairsProductMaterialTemplate').tmpl({
            materialList: data.materialDescriptionList
          }));
          $('.' + ACC.repairProducts.repairProductsContainer).show();
          $('.ph-repairsproduct_header').text(nonSerilizedListMsg);
        }
      },
      error: function() {
        $('.ph-json').text('Error');
      }
    });
  },

  loadRepairThankyouInfo: function() {
    location.hash = 'reviewfinal';

    var date = new Date();
    var options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    var stringDate = date.toLocaleDateString(document.documentElement.lang || 'en-US', options);

    $('.ph-repair__date').html(stringDate);

    var poNumber = '';

    if (localStorage.getItem(ACC.repairProducts.poNumber)) {
      $('.ph-po-num').text(localStorage.getItem(ACC.repairProducts.poNumber));
      poNumber = $('.ph-po-num').html();
      $('.ph-po').show();
    } else {
      $('.ph-po').hide();
    }

    ACC.repairProducts.productInfosDetailedList.forEach(function(prod) {
      var shipToAddress = prod.shipToAddress,
          productType = prod.productType,
          serialNumber = prod.serialNumber,
          materialNumber = prod.materialNumber,
          materialText = prod.materialText,
          partNumber = prod.partNumber,
          lotNumber = prod.lotNumber,
          orderNumber = prod.orderNumber,
          requester = '',
          queUnitAlarm = prod.queUnitAlarm,
          quePatientOnUnit = prod.quePatientOnUnit,
          queOutOfBoxFailure = prod.queOutOfBoxFailure,
          queAvailableToReturn = prod.queAvailableToReturn,
          repairIssueDescription = prod.repairIssueDescription,
          repairRelationCount = prod.repairRelationCount,
          repairRelationKey = prod.repairRelationKey,
          sendingForRepair = prod.sendingForRepair,
          serviceableProduct = true,
          patientHarmAssociated = prod.patientHarmAssociated,
          termalEventAssociated = prod.termalEventAssociated,
          parentChildSerials = prod.parentChildSerials,
          warrantyStatus = prod.warrantyStatus;


      if (prod.isMaterialService !== 'Y') {
        serviceableProduct = false;
      }

      var requestProd = {
        shipToAddress: shipToAddress,
        productType: productType,
        serialNumber: serialNumber,
        materialNumber: materialNumber,
        materialText: materialText,
        partNumber: partNumber,
        lotNumber: lotNumber,
        orderNumber: orderNumber,
        requester: requester,
        queUnitAlarm: queUnitAlarm,
        quePatientOnUnit: quePatientOnUnit,
        queOutOfBoxFailure: queOutOfBoxFailure,
        repairIssueDescription: repairIssueDescription,
        repairRelationCount: repairRelationCount,
        repairRelationKey: repairRelationKey,
        parentChildSerials: parentChildSerials,
        poNumber: poNumber,
        sendingForRepair: sendingForRepair,
        serviceableProduct: serviceableProduct,
        patientHarmAssociated: patientHarmAssociated,
        termalEventAssociated: termalEventAssociated,
        warrantyStatus: warrantyStatus
      };

      if (ACC.repairProducts.enableNewRepairField === 'true') {
        requestProd.queAvailableToReturn = queAvailableToReturn;
      }

      if (prod.materialNumber) {
        var authProd = '',
            returnNumber = 'ph-return-';

        authProd = ACC.repairProductsAjax.returnAuthNumber(prod);

        $.ajax({
          url: ACC.config.contextPath + 'repair-product/setRepairResquest.json',
          type: 'POST',
          data: requestProd,
          dataType: 'json',
          success: function(data) {
            var authNumber = data.serviceNotificationNumber;

            $('.ph-return').removeClass('ph-return__auth_process');
            $('.ph-return').addClass('ph-return__auth_number');

            if (authNumber !== null) {
              $('.' + returnNumber + authProd).html(authNumber);
            } else if (data.responseStatus === 'ERROR') {
              $('.' + returnNumber + authProd).html('ERROR');
            }
          },
          error: function() {
            $('.' + returnNumber + authProd).html('ERROR');
          }
        });
      }
    });

    if ($('.' + ACC.repairProducts.isSerializedType).val() === 'true') {
      ACC.repairProducts.populateFinalForSerial();
      $('.' + ACC.repairProducts.phSerialMsgBanner).show();
      $('.' + ACC.repairProducts.phNonserialMsgBanner).hide();
    } else {
      ACC.repairProducts.populateFinalForNonSerial();

      $('.' + ACC.repairProducts.phNonserialMsgBanner).show();
      $('.' + ACC.repairProducts.phSerialMsgBanner).hide();
    }
  },
  returnAuthNumber: function(product) {
    var authNumber = product.materialNumber;

    if (product.repairCompositeKey) {
      authNumber = product.repairCompositeKey;
    }

    return authNumber;
  },
  omnitureTaggingforCancelBtn: function(btnType) {
    var desc = 'button:repair_request:cancel';

    if (btnType === 'anotherrep') {
      desc = 'button:repair_request:thank_you:add_another_repair';
    }

    ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, desc);
  },
  landingPageOmniturTagging: function($element) {
    var elementName = $element.attr('name'),
        $question = $('.ph-question_' + elementName).text(),
        options = $element.val(),
        radioChecked = 'radio:checked',
        omnitureDesc = '';

    omnitureDesc = $question + ':' + options + ':' + radioChecked;
    ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, omnitureDesc);
  },
  productTypeOmnitureTagging: function(productType) {
    var desc = 'create_repair_request:product_info:dropdown:' + productType;

    ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, desc);
  },
  selectProductOmnitureTagging: function(prodDesc, isChecked) {
    var checked = ':unchecked',
        pageType = 'create_repair_request:product_info:',
        inputType = ':checkbox',
        desc = '';

    if (isChecked) {
      checked = ':checked';
    }

    desc = pageType + prodDesc + inputType + checked;
    ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, desc);
  },
  serialSearchOmnitureTagging: function(productArray) {
    var serialNumbers = '',
        desc = '';

    if (productArray.length > 0) {
      serialNumbers = productArray.map(function(item) {
        return item.serialNumber;
      });
      desc = 'create_repair_request:product_info:search:success:' + serialNumbers.join();
      ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, desc);
    }
  },
  bindRepairAjax: function() {
    $('.ph-repairs-deliveryaddress').click(function() {
      ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, 'button:return_shipping_information:select_address');
    });
    $(document).on('change', '.ph-issue_radiobtn', function() {
      var questionaire = $(this).attr('data-questionaire'),
          questionText = $.trim($('.ph-' + questionaire).html()),
          optionValue = $(this).val(),
          optionRadioChkd = 'radio:checked',
          omniDescForIssue = '';

      omniDescForIssue = questionText + ':' + optionValue + ':' + optionRadioChkd;

      ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, omniDescForIssue);
    });

    $(document).on('click', '.ph-repairhistory_paneltitle', function() {
      var accordionParent = $(this).parents('.ph-repairhistory_panel'),
          divAccordion = $(this).find('.' + ACC.repairProductsAjax.phAccToggle),
          ariaExpanded = 'aria-expanded',
          isExpand = divAccordion.attr(ariaExpanded);

      accordionParent.find('.ph-repairhistory_panelcollapse').toggleClass('ph-in');
      accordionParent.siblings().find('.ph-repairhistory_panelcollapse').removeClass('ph-in');

      if (isExpand === 'true') {
        accordionParent.find('.' + ACC.repairProductsAjax.phAccToggle).attr(ariaExpanded, 'false');
        $(this).addClass('ph-icon-arrow-down').removeClass('ph-icon-arrow-up');
      } else {
        accordionParent.find('.' + ACC.repairProductsAjax.phAccToggle).attr(ariaExpanded, 'true');
        $(this).removeClass('ph-icon-arrow-down').addClass('ph-icon-arrow-up');
      }
    });
    $('#poNumber').focus(function() {
      $('.ph-ponumber-tooltiptext').show();
    });
    $('.ph-issuesubmitbtn').click(function() {
      ACC.repairProductsAjax.loadRepairThankyouInfo();
    });
    $('.ph-warrantyinfo_startbtn').click(function() {
      ACC.omniture.bindTrackConversion(ACC.repairProductsAjax.omnitureType, 'button:repair_request:next_step:review_&_submit');

      if (ACC.repairProducts.activeWarrantyProducts.length > 0 || $('#' + ACC.repairProducts.phSendingforRepair).prop('checked') === true) {
        location.hash = 'reviewandsubmit';
        ACC.repairProducts.loadReviewnSubmitInfo();
      } else {
        ACC.repairProductsAjax.loadRepairThankyouInfo();
      }
    });
    $('.ph-outofservice_btn').click(function() {
      ACC.repairProductsAjax.loadRepairThankyouInfo();
    });
  },

  nonSerialThankyouMessage: function() {
    $('#' + ACC.repairProducts.reviewfinal).find('.ph-nonserviceable-border').removeClass(ACC.repairProducts.displayNone);
    $('#' + ACC.repairProducts.reviewfinal).find('.ph-nonserviceable-msz').removeClass(ACC.repairProducts.displayNone);
    $('#' + ACC.repairProducts.reviewfinal).find('.ph-serviceable-msz').addClass(ACC.repairProducts.displayNone);
  },

  serialThankyouMessage: function() {
    $('#' + ACC.repairProducts.reviewfinal).find('.ph-nonserviceable-border').addClass(ACC.repairProducts.displayNone);
    $('#' + ACC.repairProducts.reviewfinal).find('.ph-nonserviceable-msz').addClass(ACC.repairProducts.displayNone);
    $('#' + ACC.repairProducts.reviewfinal).find('.ph-serviceable-msz').removeClass(ACC.repairProducts.displayNone);
  },
  generaterepairRelationKey: function() {
    var randomValues = '',
        randomNumber = '',
        date = new Date(),
        milliSeconds = date.getTime(),
        repairRelationKey = '';

    randomValues = date.getMilliseconds();

    if (randomValues.length < 3) {
      randomNumber = randomValues * 100;
    } else {
      randomNumber = randomValues * 10;
    }

    repairRelationKey = milliSeconds + '-' + randomNumber;

    return repairRelationKey;
  },
  populateUniqueKeyCreation: function() {
    var arrayLength = ACC.repairProducts.productInfosDetailedList.length,
        parentChildSerials = '',
        relationKey = '';

    relationKey = ACC.repairProductsAjax.generaterepairRelationKey();

    if ($('.' + ACC.repairProducts.isSerializedType).val() === 'true') {
      parentChildSerials = ACC.repairProductsAjax.generateParentChildSerials();
    }

    for (var k = 0; k < arrayLength; k = k + 1) {
      ACC.repairProducts.productInfosDetailedList[k].repairRelationKey = relationKey;
      ACC.repairProducts.productInfosDetailedList[k].repairRelationCount = arrayLength;
      ACC.repairProducts.productInfosDetailedList[k].parentChildSerials = parentChildSerials;
    }
  },
  generateParentChildSerials: function() {
    var serialNumberList = '';

    serialNumberList = ACC.repairProducts.productInfosDetailedList.map(function(item) {
      return item.serialNumber;
    });

    return serialNumberList.join();
  }
};
$(document).ready(function() {
  ACC.repairProductsAjax.bindRepairAjax();
});
